import classNames from 'classnames'
import FocusTrap from 'focus-trap-react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store'
import { clearPopup, togglePopup } from 'store/reducers/popup'

export interface DefaultModalProps {
	isOpen: boolean,
	handleCloseModal: () => void,
	children: React.ReactElement,
	className?: string
}

const DefaultModal = (props: DefaultModalProps) => {
	const dispatch = useDispatch()
	const { isOpened = false } = useSelector((state: RootState) => state.popup)
	const { isOpen = false, handleCloseModal = () => { }, children, className = "" } = props

	useEffect(() => {
		if (isOpened !== isOpen) {
			dispatch(togglePopup(isOpen))
		}
		return () => {
			if (isOpened) {
				clearPopup()
			}
		}
	}, [isOpen])

	useEffect(() => {
		if (!isOpened && isOpen) handleCloseModal()
	}, [isOpened])

	const handleDefaultClose = () => {
		if (!children) handleCloseModal()
	}

	if (isOpened && isOpen)
		return (
			<FocusTrap>
				<div id="modal-wrapper" data-testid="default-modal" className={classNames("modal", className, { "is-active": isOpen })}>
					<div className="modal-background" onClick={handleDefaultClose}></div>
					<div className="modal-content flex-center">
						{children && React.cloneElement(children, { handleCloseModal })}
					</div>
				</div>
			</FocusTrap>
		)
	else return null
}

export default DefaultModal